import { Checkbox, Flex, FormControl, FormErrorMessage, Select, Tooltip } from '@chakra-ui/react'
import type { WizardTravelAdditionalData } from 'BrokerTsLib/src/dtos'
import { Insurer, Selection, SelectionType } from 'brokertslib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { FormGroup } from '../components/FormGroup'
import { FormLabel } from '../components/FormLabel'
import { FormSpacer } from '../components/FormSpacer'
import { InputGroup } from '../components/InputGroup'
import { useSelections } from '../hooks'
import { useNameof } from '../hooks/useNameof'
import { Info } from '../icons'
import { useInsuranceParamsContext } from '../layouts/Wizard'
import { BCNOptions } from './BCNOptions'
import { ICOOptions } from './ICOOptions'
import { InsureeAddressRuian } from './InsureeAddressRuian'
import InsureeContact from './InsureeContact'
import { InsureeName } from './InsureeName'
import { InsureeType } from './InsureeType'

interface AdditionalInsureeCestovkoInfoProps {
  hideContacts?: boolean
  hideInsuranceSubject?: boolean
}

export const AdditionalInsureeCestovkoInfo = ({
  hideContacts,
  hideInsuranceSubject,
}: AdditionalInsureeCestovkoInfoProps) => {
  const { insuranceParams } = useInsuranceParamsContext()
  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { data: dataTitles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = useSelections(SelectionType.TitleBefore)

  const {
    control,
    register,
    watch,
    getValues,
    getFieldState
  } = useFormContext<WizardTravelAdditionalData>()

  const nameof = useNameof<WizardTravelAdditionalData>()

  const phType = watch('policyHolder.type')
  const { error: agreementError } = getFieldState('policyHolder.agreement')
  const insurerId = getValues('insurerId')

  return (
    <>
      <InsureeType personPrefix={nameof(x => x.policyHolder)} disabled />

      <FormSpacer />

      {insurerId == Insurer.CPP &&
        isIn(phType, Selection.Company, Selection.SelfEmployed) &&
        <FormControl >
          <Flex sx={{ gap: 2 }}>
            <Checkbox {...register('policyHolder.isVatPayer')} isDisabled={isContracted}>
              Plátce DPH
            </Checkbox>
          </Flex>
        </FormControl>
      }

      {isIn(phType, Selection.Person, Selection.SelfEmployed) &&
        <>
          <BCNOptions personPrefix={nameof(x => x.policyHolder)} disabled />
          <FormGroup>
            <FormControl>
              <FormLabel>Titul před jménem</FormLabel>

              {(dataTitles?.length ?? 0) > 0 &&
                <Select
                  {...register('policyHolder.titleBefore')}
                  isDisabled={isContracted}
                  defaultValue={getValues('policyHolder.titleBefore') ?? ''}
                >
                  <option value=''>Vyberte</option>
                  {dataTitles?.map((item) => (
                    <option value={item.value?.toString()} key={item.id}>{item.value}</option>
                  ))}
                </Select>
              }
            </FormControl>

            <InsureeName personPrefix={nameof(x => x.policyHolder)} isDisabled />

            <FormControl>
              <FormLabel>Titul za jménem</FormLabel>

              <InputGroup placeholder="Např. PhD." htmlSize={8} {...register('policyHolder.titleAfter')} isDisabled={isContracted} />
            </FormControl>
          </FormGroup>
        </>
      }

      {isIn(phType, Selection.Company, Selection.SelfEmployed) && <ICOOptions personPrefix={nameof(x => x.policyHolder)} showAgent={getValues('policyHolder.agent.required') ?? false} />}

      <FormSpacer />


      <InsureeAddressRuian addressPrefix={nameof(x => x.policyHolder!.address)} isDisabled={isContracted} />

      <InsureeContact personPrefix={nameof(x => x.policyHolder)} isDisabled={isContracted} emailRequired mobileRequired />

      <FormControl isInvalid={!!agreementError?.message}>
        <Flex sx={{ gap: 2 }}>
          <Checkbox {...register('policyHolder.agreement')} isDisabled={isContracted}>
            Souhlas s elektronickou komunikací
          </Checkbox>
          <Tooltip
            shouldWrapChildren
            hasArrow
            label="Souhlas s elektronickou komunikací"
            placement="top"
          >
            <Info color="blue.500" />
          </Tooltip>
        </Flex>
        {<FormErrorMessage>{agreementError?.message}</FormErrorMessage>}
      </FormControl>

      <FormSpacer />

      {/* {!hideInsuranceSubject && (
        <>
          <FormControl>
            <FormLabel>Pojištění je sjednáváno pro</FormLabel>

            <RadioGroup name="insuranceSubject" control={control}>
              <RadioStack variant="stackedTile">
                <Radio value="subject">Sebe nebo rodinu</Radio>
                <Radio value="third-party">Třetí osobu</Radio>
              </RadioStack>
            </RadioGroup>
          </FormControl>

          {insuranceSubject === 'third-party' && (
            <FormControl sx={{ width: '100%' }}>
              <FormLabel>Bližší specifikace</FormLabel>

              <InputGroup
                name="thirdPartySpecification"
                htmlSize={120}
                placeholder="Přiblížení sjednání pro třetí osobu"
                sx={{ width: '100%' }}
              />
            </FormControl>
          )}
        </>
      )} */}
    </>
  )
}
